import React from "react";
import countryCodesList from "./countryCodes.json";
import { CountryCodeJsonType, SelectCountryType } from "./type";
import { CustomSelectOptionType } from "shared/form/core/types";
import CustomSelectDropdown from "shared/form/core/customSelectDropdown";
import { useCopies } from "shared/hooks/useCopies";

/**
 * @name SelectCountryDropdown
 * @description This is used to select country in phone number component
 * @param onChange
 * @param selectedOptionLabelCallback
 * @param props
 * @constructor
 */
export default function SelectCountryDropdown({ onChange, selectedOptionLabelCallback, ...props }: SelectCountryType) {
  const copies = useCopies();
  const [countryCode, setCountryCode] = React.useState(() => {
    const countryObj = countryCodesList.find(
      (item: CountryCodeJsonType) => item.iso2 === props.countryCode.toLowerCase() && item.code === props.dialCode
    );
    return countryObj ? countryObj.iso2 : countryCodesList.find(country => country.code === props.dialCode)?.iso2;
  });

  const options: Array<CustomSelectOptionType> = countryCodesList.map(item => {
    return {
      selectedLabel: selectedOptionLabelCallback ? selectedOptionLabelCallback(item) : getSelectedOptionLabel(item),
      value: item.iso2,
      label: getOptionLabel(item),
      searchFieldValue: `${item.name} +${item.code}`
    };
  });

  const defaultValue = React.useMemo(() => {
    const item = countryCodesList.find(obj => obj.iso2 === countryCode);
    if (!item) {
      return;
    }
    return {
      label: getOptionLabel(item),
      value: item?.iso2,
      selectedLabel: selectedOptionLabelCallback ? selectedOptionLabelCallback(item) : getSelectedOptionLabel(item)
    };
  }, [countryCode, selectedOptionLabelCallback]);

  const onChangeHandler = React.useCallback(
    (selectedItem: CustomSelectOptionType) => {
      setCountryCode(selectedItem.value);
      const selectedCountryObj = countryCodesList.find(item => item.iso2 === selectedItem.value);
      onChange?.({
        dialCode: selectedCountryObj?.code || "",
        countryCode: selectedCountryObj?.iso2 || ""
      });
    },
    [onChange]
  );
  return (
    <React.Fragment>
      <CustomSelectDropdown
        name={props.name}
        options={options}
        value={defaultValue}
        onBlur={props.onBlur}
        disabled={props.disabled}
        onChange={onChangeHandler}
        placeholder={copies.get("search")}
        label={copies.get("select.country.code")}
      />
    </React.Fragment>
  );
}

function getOptionLabel(item: CountryCodeJsonType) {
  return `<span 
  class='${"customSelect_dropdown_optionsList_item_flag cflag " + item.iso2.toUpperCase()}'></span>
  <span class="customSelect_dropdown_optionsList_item_name">${item.name}</span>
  <small class="customSelect_dropdown_optionsList_item_code">(+${item.code})</small>`;
}

function getSelectedOptionLabel(item: CountryCodeJsonType) {
  return `
  <span class='${
    "customSelect_dropdown_selectedOption_details_additionalOption cflag " + item.iso2.toUpperCase()
  }'></span>
  <small class="customSelect_dropdown_selectedOption_details_code">+${item.code}</small>
  `;
}
